import { app } from '../../../../app';

app.component('profilesInfo', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./info.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/info/info.component.js